/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable sonarjs/no-collapsible-if */
/* eslint-disable import/no-duplicates */
import { Component, OnInit } from '@angular/core';
import {
  Router,
  Event as RouterEvent,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError,
} from '@angular/router';
// eslint-disable-next-line @nx/enforce-module-boundaries
import {
  AppstateService,
  AppstateFacade,
} from '@cigna/cigna-for-brokers/shell/data-access';
import { Subject } from 'rxjs';
import { HostListener } from '@angular/core';

@Component({
  selector: 'cigna-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'cigna-for-brokers';
  isApploading = true;
  isShowErrMessage = false;
  isLoginPage = true;
  isFromBRPortal: string;
  private _ngUnsubscribe$: Subject<void> = new Subject<void>();

  @HostListener('window:popstate', ['$event'])
  onPopState() {
    this.router.navigateByUrl(`${window.location.pathname}`, {
      onSameUrlNavigation: 'reload',
      skipLocationChange: true,
    });
  }

  constructor(
    private router: Router,
    private appStateService: AppstateService,
    public _appstateFacade: AppstateFacade,
  ) {}
  ngOnInit(): void {
    this.router.events.subscribe((e: RouterEvent) => {
      this.navigationInterceptor(e);
    });
    this.appStateService.showErrorMsg.subscribe((res) => {
      this.isShowErrMessage = res;
    });
  }

  navigationInterceptor(event: RouterEvent): void {
    if (event instanceof NavigationStart) {
      this.isApploading = true;
    }
    if (event instanceof NavigationEnd) {
      this.isApploading = false;
    }

    // Set loading state to false in both of the below events to hide the spinner in case a request fails
    if (event instanceof NavigationCancel) {
      this.isApploading = false;
    }
    if (event instanceof NavigationError) {
      this.isApploading = false;
    }
  }
}
